import { UserAvatarSmall } from '../../../user-avatar/user-avatar-small';
import globalUserProfile from '../../../../stores/global-user-profile';
import React, { useState, useRef } from 'react';
import { UserProfileDialog } from './user-profile-dialog';
import { observer } from 'mobx-react-lite';
import { Tooltip } from 'primereact/tooltip';

interface SideBarUserProfileProps {
  collapsed?: boolean;
}

export const SideBarUserProfile = observer(
  ({ collapsed = false }: SideBarUserProfileProps) => {
    const [showProfileDialog, setShowProfileDialog] = useState<boolean>(false);
    const isClosingRef = useRef<boolean>(false);

    const handleOpenDialog = (e: React.MouseEvent) => {
      e.stopPropagation();
      if (!isClosingRef.current && !showProfileDialog) {
        setShowProfileDialog(true);
      }
    };

    const handleCloseDialog = () => {
      isClosingRef.current = true;
      setShowProfileDialog(false);
      setTimeout(() => {
        isClosingRef.current = false;
      }, 1);
    };

    if (
      !globalUserProfile.isFullProfileLoaded ||
      !globalUserProfile.userProfile?.userWithRole
    ) {
      return null;
    }

    return (
      <>
        <Tooltip target="[data-pr-tooltip]" />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: collapsed ? 'center' : 'flex-start',
            padding: collapsed ? '16px 8px' : '16px 0',
            paddingRight: collapsed ? '8px' : '16px',
            borderTop: '1px solid var(--surface-200)',
            marginTop: '16px',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease',
          }}
          onClick={handleOpenDialog}
          data-pr-tooltip={
            collapsed
              ? `${globalUserProfile.userProfile?.userWithRole.firstName} ${globalUserProfile.userProfile?.userWithRole.lastName}`
              : undefined
          }
          data-pr-position="left"
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--surface-50)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
        >
          <div
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              backgroundColor: 'var(--surface-200)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: collapsed ? '0' : '12px',
              overflow: 'hidden',
              flexShrink: 0,
            }}
          >
            <UserAvatarSmall
              imageUrl={`${globalUserProfile.userProfile?.userWithRole.fileUrl}`}
              firstName={globalUserProfile.userProfile?.userWithRole.firstName}
              lastName={globalUserProfile.userProfile?.userWithRole.lastName}
            />
          </div>
          {!collapsed && (
            <span style={{ color: 'var(--surface-900)', fontWeight: 500 }}>
              {globalUserProfile.userProfile?.userWithRole.firstName}{' '}
              {globalUserProfile.userProfile?.userWithRole.lastName}
            </span>
          )}

          <UserProfileDialog
            visible={showProfileDialog}
            onHide={handleCloseDialog}
            user={globalUserProfile.userProfile?.userWithRole}
          />
        </div>
      </>
    );
  },
);
